import { render, staticRenderFns } from "./gocco-header-next-query.vue?vue&type=template&id=3747023e&"
import script from "./gocco-header-next-query.vue?vue&type=script&lang=ts&"
export * from "./gocco-header-next-query.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports